import Vue from 'vue'
import VuePageTitle from 'vue-page-title'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'vue-nprogress'
// import FirebaseAuthService from './services/firebase'
import LaravelAuthService from './services/laravel_auth'
import TransmitService from './services/transmit'
import Mockup from './services/mockup'
import './registerServiceWorker'
import './global.scss'
import XLSX from 'xlsx'

import {
  Avatar, TreeSelect, Rate, Breadcrumb, InputNumber, Steps, Message,
  Upload, Button, Layout, Table, Icon, Progress, Radio, Dropdown, Menu,
  Carousel, Input, Calendar, Badge, Slider, Form, Tooltip, Select, Switch,
  Tag, Affix, Spin, Alert, Checkbox, Tabs, Pagination, notification, Drawer,
  List, ConfigProvider, FormModel, Modal, AutoComplete, Card, DatePicker, TimePicker, Row, Col, Popconfirm,
  Collapse,
} from 'ant-design-vue'

Vue.use(ConfigProvider)
Vue.use(Avatar)
Vue.use(Button)
Vue.use(Rate)
Vue.use(TreeSelect)
Vue.use(Breadcrumb)
Vue.use(Layout)
Vue.use(Table)
Vue.use(Icon)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Carousel)
Vue.use(Input)
Vue.use(Calendar)
Vue.use(Badge)
Vue.use(Slider)
Vue.use(Form)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Tag)
Vue.use(Affix)
Vue.use(Spin)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Message)
Vue.use(Steps)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(notification)
Vue.use(List)
Vue.use(FormModel)
Vue.use(Modal)
Vue.use(AutoComplete)
Vue.use(Card)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popconfirm)
Vue.use(Collapse)

Vue.use(XLSX)

Vue.prototype.$notification = notification
Vue.prototype.$message = Message

Vue.use(Mockup)
Vue.use(TransmitService)
Vue.use(NProgress)
// Vue.use(FirebaseAuthService)
Vue.use(LaravelAuthService)
Vue.use(VuePageTitle, {
  prefix: 'AI-Contact | ',
  router,
})
Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  render: h => h(App),
}).$mount('#app')
